(() => {
  function closeOthers(container, opened) {
    container.querySelectorAll('details').forEach((details) => {
      if (details !== opened && details.open) details.removeAttribute('open');
    });
  }

  document.addEventListener(
    'toggle',
    (event) => {
      const opened = event.target;
      if (!(opened instanceof HTMLDetailsElement) || !opened.open) return;

      const mission = opened.closest('[data-ecojay-exclusive-details="mission"]');
      if (mission) {
        closeOthers(mission, opened);
        return;
      }

      const productInfo = opened.closest('[data-ecojay-exclusive-details="product"]');
      if (!productInfo) return;
      if (!opened.closest('.product__accordion')) return;

      productInfo.querySelectorAll('.product__accordion details').forEach((details) => {
        if (details !== opened && details.open) details.removeAttribute('open');
      });
    },
    true
  );
})();
